import { getIconComponent } from '@/components/modals/IconPicker';

interface TagsTabProps {
  tags: any[];
  onAdd: () => void;
  onEdit: (t: any) => void;
}

export function TagsTab({ tags, onAdd, onEdit }: TagsTabProps) {
  return (
    <div className="max-w-3xl">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-base font-semibold text-text-primary">Tags</h2>
        <button onClick={onAdd} className="px-3 py-1.5 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700">
          + Add tag
        </button>
      </div>
      <div className="border border-border-default rounded-md overflow-hidden">
        <table className="w-full border-collapse">
          <thead className="bg-background-secondary">
            <tr className="border-b border-gray-200">
              <th className="text-left py-2 px-4 text-xs font-semibold text-text-secondary">Name</th>
              <th className="text-left py-2 px-4 text-xs font-semibold text-text-secondary">Icon</th>
              <th className="text-center py-2 px-4 text-xs font-semibold text-text-secondary">Badge</th>
              <th className="text-center py-2 px-4 text-xs font-semibold text-text-secondary">Icon</th>
              <th className="text-left py-2 px-4 text-xs font-semibold text-text-secondary">Description</th>
              <th className="text-right py-2 px-4 text-xs font-semibold text-text-secondary">Actions</th>
            </tr>
          </thead>
          <tbody>
            {tags.map((tag) => {
              const IconComponent = getIconComponent(tag.icon);
              return (
                <tr key={tag.id} className="border-b border-gray-100 last:border-0 hover:bg-surface-hover">
                  <td className="py-2 px-4 text-sm text-text-primary">{tag.name}</td>
                  <td className="py-2 px-4">
                    {IconComponent && <IconComponent className="h-4 w-4 text-text-secondary" />}
                  </td>
                  <td className="py-2 px-4 text-center text-sm text-text-secondary">{tag.displayAsBadge ? '✓' : ''}</td>
                  <td className="py-2 px-4 text-center text-sm text-text-secondary">{tag.displayAsIcon ? '✓' : ''}</td>
                  <td className="py-2 px-4 text-xs text-text-secondary">{tag.description || '—'}</td>
                  <td className="py-2 px-4 text-right">
                    <button onClick={() => onEdit(tag)} className="text-xs text-blue-600 hover:text-blue-700 font-medium">Edit</button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {tags.length === 0 && (
          <p className="py-6 text-center text-sm text-text-secondary">No tags yet.</p>
        )}
      </div>
    </div>
  );
}
